export default {"src":"/_next/static/media/questionMark.93888966.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};